import Component from '../../Component';
import { setCookie } from '../../helpers/helpers';
import PerfectScrollbar from 'perfect-scrollbar';
import {DateTime} from "luxon";
require('perfect-scrollbar/css/perfect-scrollbar.css')
import 'slick-carousel/slick/slick.min.js'
require('slick-carousel/slick/slick.css')

import Reactions from '../../reactions/Reactions';

class EPGView extends Component {
    constructor(model) {
        super();
        this._model = model;
        this.state = {
            program: [],
            daily_program: [],
            playing: null,
            active: null,
            volume: 50,
            uhd: false,
        }

        this.config = {
            pg: {
                "18": "korhatar18_360p.mp4",
                "16": "korhatar16_360p.mp4",
                "12": "korhatar12_360p.mp4",
                "6": "korhatar6_360p.mp4",
                "No PG": "feliratozva_360p.mp4",
                "": "feliratozva_360p.mp4",
            }
        }

        this.volume = 0.5;
        this.video_position = 0;
        this.videoProgressInterval = null;
        this.pg_scrollbar = null;

        this.setup();
    }

    renderProgramGuide(guide) {
        if (!Object.keys(guide).length) {
            $('.program-guide').removeClass('loading');
            return;
        }
        let source = 'daily_program';
        let iso_date = Object.keys(guide)[0];
        let rows = guide[iso_date].map(item => {
            let display_time = item.startTime_dt.split('T')[1].split('Z')[0].split(':').splice(0, 2).join(':');
            let available = this.state[source].find(p => p.id === item.id && !p.inactive);
            return `
        <div class="guide-row  " ${available ? `data-id="${item.id}"` : ''} >
          <div class="guide-time">
            ${display_time ? display_time : ""}
          </div>
          <div class="guide-titles">
            ${available ? '<i class="fas fa-play-circle play-btn"></i>' : ''}
            <div class="titles">
              <h5>${item.title}<h5>
              <h6>${item.subtitle ? item.subtitle : '<br>'}</h6>
            </div>
            <div class="icons">
              ${ !isNaN(item.pg) ? `
              <div class="guide-pg">
                <span class="pg pg-${item.pg}">${isNaN(item.pg) ? "" : item.pg}</span>
              </div>
              ` : ''}

              ${ item.hasSubtitle ? `
              <i class="far fa-closed-captioning"></i>
              ` : ''}
              ${ item.quality && item.quality !== 'SD' ? `<span class="guide-icon show-icon resolution-icon ${item.quality}">${item.quality}</span>` : ''}
            </div>
          </div>
        </div>
      `
        })
        $('.program-guide').html(rows.join(''))
        $('.program-guide').removeClass('loading');

        setTimeout(() => {
            this.pg_scrollbar.update();
        }, 100)

        let next = DateTime.fromISO(iso_date).plus({day: 1});
        let prev = DateTime.fromISO(iso_date).minus({day: 1});
        let start = DateTime.now().minus({day: 2});
        let end = DateTime.now().plus({day: 7});

        if (prev < start) {
            $('.guide-arrow.prev').fadeOut();
            $('.program-guide-date .prev [data-date]').fadeOut();
        } else {
            $('.guide-arrow.prev').attr('data-date', prev.toISODate());
            $('.guide-arrow.prev').fadeIn();
            $('.program-guide-date .prev [data-date]').attr('data-date', prev.toISODate());
            $('.program-guide-date .prev [data-date]').fadeIn();
        }

        if (next > end) {
            $('.guide-arrow.next').fadeOut();
            $('.program-guide-date .next [data-date]').fadeOut();
        } else {
            $('.guide-arrow.next').attr('data-date', next.toISODate());
            $('.guide-arrow.next').fadeIn();
            $('.program-guide-date .next [data-date]').attr('data-date', next.toISODate());
            $('.program-guide-date .next [data-date]').fadeIn();
        }

        let title = DateTime.fromISO(iso_date).setLocale('hu').toFormat("LLLL d'.' EEEE");
        $('.program-guide-date .pg-date').css("text-transform", "capitalize");
        $('.program-guide-date .pg-date').html(title);
    }
    setup() {
        this._model.getTime();
        this.pg_scrollbar = new PerfectScrollbar('#embed_program_guide');

        $('.active-extended-info-modal .ps__rail-x, .active-extended-info-modal .ps__rail-y').click(e => {
            e.stopPropagation();
        })

        $('#program_guide_container .prev, #program_guide_container .next').click((e) => {
            let date = $(e.target).closest('[data-date]').attr('data-date');
            $('.program-guide').addClass('loading');
            this._model.getProgramGuide(date)
        });
    }
}

export default EPGView;
